<i class="fa fa-times close" mat-dialog-close aria-hidden="true"></i>
<h3 mat-dialog-title i18n>Biztosan visszaállítja {{selectedUser.name}} jelszavát az alapértelmezettre?</h3>
<mat-dialog-content class="mat-typography">
    <div class="modifyWindowForm form-inline mt-3">
        <button (click)="resetPassword()" i18n>Igen</button>
        <button mat-dialog-close i18n>Nem</button>
    </div>
</mat-dialog-content>
